import { i as w, x as p, s as c } from "../../../lit-element-6iugfgmM.js";
import { e as f } from "../../../custom-element-wk-AooBb.js";
import { n as i } from "../../../property-BWlAHqg_.js";
import { t as h } from "../../../state-STZTbIJp.js";
import "../../../query-assigned-elements-B8U94KLQ.js";
import "../../../sp-button-fa52iiKJ.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-checkmark.js";
import "../../../sp-overlay-C7imRS_0.js";
import s from "../../../events/NotificationEvent.js";
import { Localize as u } from "../../../lib/I18N.js";
import { r as d, a as k } from "../../../Libraries-BoeFPC98.js";
import m from "../../../events/LibraryFollowEvent.js";
const g = { "follow-library-button.label": "Follow library", "follow-library-button.following": "Following", "follow-library-button.follow-success": "{libraryName} was added to your libraries", "follow-library-button.follow-error": "There was a problem following the library. Please try again later.", "follow-library-button.unfollow-success": "{libraryName} was removed from your libraries", "follow-library-button.unfollow-error": "There was a problem unfollowing the library. Please try again later." }, v = w``;
var B = Object.defineProperty, N = Object.getOwnPropertyDescriptor, t = (l, e, n, a) => {
  for (var b, o = a > 1 ? void 0 : a ? N(e, n) : e, y = l.length - 1; y >= 0; y--) (b = l[y]) && (o = (a ? b(e, n, o) : b(o)) || o);
  return a && o && B(e, n, o), o;
};
let r = class extends u(c, g) {
  constructor() {
    super(...arguments), this.bookmarkId = "", this.libraryName = "", this.libraryUrn = "", this.publicLibraryId = "", this.followed = !1;
  }
  static get styles() {
    return v;
  }
  render() {
    return this.followed ? this.renderUnfollowButton() : this.renderFollowButton();
  }
  renderFollowButton() {
    return p`<sp-button emphasized id="follow" @click="${this._addBookmark}">${this.t("follow-library-button.label")}</sp-button>`;
  }
  renderUnfollowButton() {
    return p`<sp-button emphasized id="unfollow" @click="${this._removeBookmark}"><sp-icon-checkmark slot="icon" size="s"></sp-icon-checkmark>${this.t("follow-library-button.following")}</sp-button>`;
  }
  async _removeBookmark() {
    try {
      await d(this.bookmarkId), this.followed = !1, this.dispatchEvent(new m({ libraryUrn: this.libraryUrn })), this.dispatchEvent(new s({ type: "success", message: this.t("follow-library-button.unfollow-success", { libraryName: this.libraryName }) }));
    } catch {
      this.dispatchEvent(new s({ type: "error", message: this.t("follow-library-button.unfollow-error") }));
    }
  }
  async _addBookmark() {
    try {
      await k(this.bookmarkId), this.followed = !0, this.dispatchEvent(new m({ libraryUrn: this.libraryUrn })), this.dispatchEvent(new s({ type: "success", message: this.t("follow-library-button.follow-success", { libraryName: this.libraryName }) }));
    } catch {
      this.dispatchEvent(new s({ type: "error", message: this.t("follow-library-button.follow-error") }));
    }
  }
};
t([i({ type: String })], r.prototype, "bookmarkId", 2), t([i({ type: String })], r.prototype, "libraryName", 2), t([i({ type: String })], r.prototype, "libraryUrn", 2), t([i({ type: String })], r.prototype, "publicLibraryId", 2), t([h()], r.prototype, "followed", 2), r = t([f("af-follow-library-button")], r);
const j = r;
export {
  j as default
};
//# sourceMappingURL=FollowLibraryButton.js.map
